import React, { useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import checked from '../../../Assets/sanadSVG/Active.svg';
import { ReactSVG } from 'react-svg';
import { useTranslation } from 'react-i18next';
import { MainContext } from '../../../Context/MainContext';
import { ApisContext } from '../../../Context/ApisContext';


const Options = () => {
	const { setToggleMenu,
		ActiveClass,
		handleActiveClass,
		blue,
		gray,
		classSvg,
	} = useContext(MainContext);
	const { Role } = useContext(ApisContext);

	const [t] = useTranslation();



	const { pathname } = useLocation()

	useEffect(() => {
		if (pathname.includes("/course")) {
			handleActiveClass(2);
			sessionStorage.setItem("activeClass", 2);
		} else if (pathname.includes("/assistant")) {
			handleActiveClass(3);
			sessionStorage.setItem("activeClass", 3);
		}
		else if (pathname.includes("/exam")) {
			handleActiveClass(4);
			sessionStorage.setItem("activeClass", 4);
		} else if (pathname.includes("/announcements")) {
			handleActiveClass(6);
			sessionStorage.setItem("activeClass", 6);
		} else {
			handleActiveClass(1);
			sessionStorage.setItem("activeClass", 1);
		}
	}, [pathname]);

	// useEffect(() => {
	// 	sessionStorage.setItem('activeClass', ActiveClass);
	// }, [ActiveClass]);

	return (
		<ul className="list-none  flex flex-col gap-y-4 w-full px-3 ">
			<li className="flex relative " onClick={() => setToggleMenu(false)}>
				<Link
					className={`transition  decoration-clone w-full ${ActiveClass == 1 ? 'text-mainColor' : 'text-textGray'
						} cursor-pointer flex items-center`}
					to={'/'}
					onClick={() => {
						handleActiveClass(1);
					}}
				>
					<svg
						className="w-5 h-5 sm:w-7 sm:h-7"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							id="Vector"
							opacity="0.4"
							d="M18.0402 4.81969L12.2802 0.789694C10.7102 -0.310306 8.30023 -0.250306 6.79023 0.919694L1.78023 4.82969C0.780234 5.60969 -0.00976562 7.20969 -0.00976562 8.46969V15.3697C-0.00976562 17.9197 2.06023 19.9997 4.61023 19.9997H15.3902C17.9402 19.9997 20.0102 17.9297 20.0102 15.3797V8.59969C20.0102 7.24969 19.1402 5.58969 18.0402 4.81969Z"
							fill="url(#paint0_linear_4978_24234)"
						/>
						<defs>
							<linearGradient
								id="paint0_linear_4978_24234"
								x1="-0.00976562"
								y1="0.00195313"
								x2="19.988"
								y2="20.0219"
								gradientUnits="userSpaceOnUse"
							>
								<stop
									stopColor={ActiveClass === 1 ? '#023E8A' : 'gray'}
									stopOpacity="0.7"
								/>
								<stop
									offset="0.723958"
									stopColor={ActiveClass === 1 ? '#2684FF' : 'gray'}
									stopOpacity="0.8"
								/>
							</linearGradient>
						</defs>
					</svg>

					<span className="flex ps-3 text-base sm:text-size_18  font-bold capitalize">
						{t('dashboard.main')}
					</span>
				</Link>
				{ActiveClass === 1 && <ReactSVG src={checked} />}
			</li>

			<li className="flex relative " onClick={() => setToggleMenu(false)}>
				<Link
					className={`transition  decoration-clone w-full ${ActiveClass === 2 ? 'text-mainColor' : 'text-textGray'
						} cursor-pointer flex items-center`}
					to={'/courses'}
					onClick={() => {
						handleActiveClass(2);
						// setToggleMenu()
					}}
				>
					<svg
						className="w-5 h-5 sm:w-7 sm:h-7"
						viewBox="0 0 21 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M2.8 1.41176H14C14.3713 1.41176 14.7274 1.5605 14.9899 1.82526C15.2525 2.09002 15.4 2.44911 15.4 2.82353V9.91341C15.8737 9.95668 16.3423 10.0441 16.8 10.1746V2.82353C16.8 2.07468 16.505 1.35651 15.9799 0.826993C15.4548 0.297478 14.7426 0 14 0H2.8C2.05739 0 1.3452 0.297478 0.820101 0.826993C0.294999 1.35651 0 2.07468 0 2.82353V19.7647C0 20.5136 0.294999 21.2317 0.820101 21.7612C1.3452 22.2908 2.05739 22.5882 2.8 22.5882H8.7598C8.40323 22.1528 8.0948 21.6794 7.84 21.1765H2.8C2.4287 21.1765 2.0726 21.0277 1.81005 20.763C1.5475 20.4982 1.4 20.1391 1.4 19.7647H7.2898C7.16026 19.3032 7.07355 18.8306 7.0308 18.3529H1.4V2.82353C1.4 2.44911 1.5475 2.09002 1.81005 1.82526C2.0726 1.5605 2.4287 1.41176 2.8 1.41176ZM4.2 2.82353C3.8287 2.82353 3.4726 2.97227 3.21005 3.23703C2.9475 3.50178 2.8 3.86087 2.8 4.23529V5.64706C2.8 6.02148 2.9475 6.38057 3.21005 6.64533C3.4726 6.91008 3.8287 7.05882 4.2 7.05882H12.6C12.9713 7.05882 13.3274 6.91008 13.5899 6.64533C13.8525 6.38057 14 6.02148 14 5.64706V4.23529C14 3.86087 13.8525 3.50178 13.5899 3.23703C13.3274 2.97227 12.9713 2.82353 12.6 2.82353H4.2ZM12.6 4.23529V5.64706H4.2V4.23529H12.6ZM21 17.6471C21 19.332 20.3363 20.9479 19.1548 22.1393C17.9733 23.3307 16.3709 24 14.7 24C13.0291 24 11.4267 23.3307 10.2452 22.1393C9.06375 20.9479 8.4 19.332 8.4 17.6471C8.4 15.9622 9.06375 14.3463 10.2452 13.1549C11.4267 11.9634 13.0291 11.2941 14.7 11.2941C16.3709 11.2941 17.9733 11.9634 19.1548 13.1549C20.3363 14.3463 21 15.9622 21 17.6471ZM14.028 14.8715C13.9372 14.8087 13.8317 14.7708 13.722 14.7616C13.6122 14.7525 13.502 14.7723 13.4022 14.8193C13.3207 14.8554 13.247 14.9072 13.1852 14.9718C13.0548 15.1065 12.9819 15.2875 12.9822 15.4758V19.8169C12.9813 19.9105 12.9988 20.0033 13.0337 20.0901C13.0685 20.1768 13.12 20.2558 13.1852 20.3224C13.2491 20.3864 13.3235 20.439 13.405 20.4776C13.547 20.5433 13.7082 20.5533 13.8572 20.5059C13.9217 20.4844 13.983 20.454 14.0392 20.4155L17.2536 18.2033C17.3514 18.1383 17.4302 18.0481 17.4818 17.9421C17.535 17.8353 17.5623 17.7173 17.5616 17.5978C17.5609 17.4783 17.5321 17.3607 17.4776 17.2546C17.4229 17.1501 17.3423 17.0616 17.2438 16.9976L14.028 14.8715Z"
							fill={ActiveClass === 2 ? blue : gray}
						/>
					</svg>

					<span className="flex ps-3 text-base sm:text-size_18   font-bold capitalize">
						{t('dashboard.courses')}
					</span>
				</Link>
				{ActiveClass === 2 && <ReactSVG src={checked} />}
			</li>

			{Role === 3 && (
				<li className="flex relative " onClick={() => setToggleMenu(false)}>
					<Link
						className={`transition  decoration-clone w-full ${ActiveClass === 3 ? 'text-mainColor' : 'text-textGray'
							} cursor-pointer flex items-center`}
						to={'assistants'}
						onClick={() => {
							handleActiveClass(3);
						}}
					>
						<svg
							className={`${classSvg}`}
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M10.9921 14.8053C11.9973 14.1361 12.7605 13.1612 13.1687 12.0248C13.577 10.8883 13.6087 9.65061 13.2591 8.49474C12.9095 7.33887 12.1973 6.32618 11.2276 5.60642C10.258 4.88666 9.0825 4.49805 7.87492 4.49805C6.66735 4.49805 5.49184 4.88666 4.52221 5.60642C3.55258 6.32618 2.84032 7.33887 2.49076 8.49474C2.1412 9.65061 2.17288 10.8883 2.58114 12.0248C2.9894 13.1612 3.75255 14.1361 4.75774 14.8053C2.93945 15.4755 1.38659 16.7156 0.330862 18.3406C0.275377 18.4231 0.236837 18.5158 0.217482 18.6133C0.198127 18.7108 0.198344 18.8111 0.218119 18.9085C0.237895 19.0059 0.276835 19.0984 0.332676 19.1807C0.388516 19.2629 0.460144 19.3332 0.543396 19.3875C0.626647 19.4418 0.719861 19.479 0.81762 19.497C0.915378 19.5149 1.01573 19.5133 1.11285 19.4921C1.20996 19.4709 1.3019 19.4307 1.38332 19.3737C1.46473 19.3167 1.53401 19.244 1.58711 19.16C2.2681 18.1126 3.19995 17.2519 4.29802 16.6561C5.3961 16.0603 6.62562 15.7482 7.87492 15.7482C9.12423 15.7482 10.3538 16.0603 11.4518 16.6561C12.5499 17.2519 13.4817 18.1126 14.1627 19.16C14.2727 19.3235 14.4427 19.4371 14.6358 19.4763C14.8289 19.5156 15.0297 19.4772 15.1947 19.3695C15.3598 19.2619 15.4758 19.0936 15.5178 18.9011C15.5598 18.7085 15.5243 18.5072 15.419 18.3406C14.3633 16.7156 12.8104 15.4755 10.9921 14.8053ZM3.74992 10.1253C3.74992 9.30948 3.99185 8.51195 4.44511 7.8336C4.89837 7.15525 5.54261 6.62654 6.29636 6.31433C7.0501 6.00212 7.8795 5.92043 8.67967 6.07959C9.47984 6.23875 10.2148 6.63162 10.7917 7.20851C11.3686 7.78541 11.7615 8.52041 11.9207 9.32058C12.0798 10.1208 11.9981 10.9502 11.6859 11.7039C11.3737 12.4576 10.845 13.1019 10.1667 13.5551C9.4883 14.0084 8.69077 14.2503 7.87492 14.2503C6.78129 14.2491 5.7328 13.8141 4.95948 13.0408C4.18616 12.2675 3.75117 11.219 3.74992 10.1253ZM23.4506 19.3785C23.284 19.4871 23.081 19.5251 22.8864 19.4841C22.6918 19.4432 22.5214 19.3266 22.4127 19.16C21.7326 18.112 20.8008 17.2509 19.7025 16.6554C18.6042 16.0598 17.3743 15.7487 16.1249 15.7503C15.926 15.7503 15.7352 15.6713 15.5946 15.5307C15.4539 15.39 15.3749 15.1992 15.3749 15.0003C15.3749 14.8014 15.4539 14.6107 15.5946 14.47C15.7352 14.3293 15.926 14.2503 16.1249 14.2503C16.7324 14.2498 17.3322 14.115 17.8816 13.8557C18.431 13.5965 18.9163 13.2191 19.3029 12.7505C19.6895 12.2819 19.9678 11.7337 20.118 11.1451C20.2682 10.5565 20.2865 9.94198 20.1716 9.34547C20.0568 8.74895 19.8116 8.18516 19.4536 7.69439C19.0956 7.20361 18.6337 6.79796 18.1007 6.50642C17.5678 6.21488 16.977 6.04465 16.3707 6.00789C15.7643 5.97113 15.1573 6.06875 14.5931 6.29377C14.501 6.33354 14.402 6.35447 14.3018 6.35531C14.2016 6.35616 14.1022 6.33691 14.0095 6.2987C13.9169 6.26049 13.8328 6.20409 13.7623 6.13284C13.6918 6.0616 13.6363 5.97694 13.5991 5.88388C13.5619 5.79082 13.5437 5.69124 13.5456 5.59103C13.5475 5.49082 13.5695 5.39201 13.6102 5.30044C13.651 5.20887 13.7097 5.12639 13.7828 5.05788C13.856 4.98938 13.9421 4.93623 14.0362 4.90158C15.3275 4.38656 16.7639 4.36803 18.0681 4.84955C19.3723 5.33108 20.452 6.27854 21.0989 7.50916C21.7458 8.73978 21.914 10.1664 21.5711 11.5137C21.2283 12.861 20.3986 14.0336 19.2421 14.8053C21.0604 15.4755 22.6133 16.7156 23.669 18.3406C23.7776 18.5072 23.8156 18.7102 23.7747 18.9048C23.7337 19.0994 23.6171 19.2698 23.4506 19.3785Z"
								fill={ActiveClass == 3 ? blue : gray}
							/>
						</svg>

						<span className="flex ps-3 text-base sm:text-size_18   font-bold capitalize">
							{t('dashboard.assistants')}
						</span>
					</Link>
					{ActiveClass === 3 && <ReactSVG src={checked} />}
				</li>
			)}
			{Role === 3 && (
				<li className="flex relative " onClick={() => setToggleMenu(false)}>
					<Link
						className={`transition  decoration-clone w-full ${ActiveClass === 4 ? 'text-mainColor' : 'text-textGray'
							} cursor-pointer flex items-center`}
						to={'/exams'}
						onClick={() => {
							handleActiveClass(4);
							// setToggleMenu()
						}}
					>
						<svg
							width={21}
							height={24}
							viewBox="0 0 21 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M1.75 3.39537V18.1579C1.75 19.2886 2.24781 20.3729 3.13392 21.1724C4.02003 21.9719 5.22185 22.4211 6.475 22.4211H17.2368C17.001 22.8917 16.6198 23.291 16.1388 23.5711C15.6578 23.8511 15.0975 24 14.525 24H6.475C4.75772 24 3.11078 23.3845 1.89648 22.2889C0.682185 21.1933 8.51448e-08 19.7073 8.51448e-08 18.1579V5.8421C-0.00013685 5.32559 0.164899 4.82001 0.475307 4.38602C0.785716 3.95202 1.22831 3.60805 1.75 3.39537ZM11.7299 2.60723e-08C12.1207 -4.91151e-05 12.5077 0.0693683 12.8687 0.204287C13.2297 0.339205 13.5578 0.536981 13.8341 0.786316L20.1285 6.46547C20.4048 6.71478 20.624 7.01076 20.7736 7.33651C20.9231 7.66227 21.0001 8.01141 21 8.364V18.1579C21 18.8698 20.6866 19.5525 20.1286 20.0559C19.5707 20.5593 18.814 20.8421 18.025 20.8421H6.475C5.68598 20.8421 4.92928 20.5593 4.37136 20.0559C3.81344 19.5525 3.5 18.8698 3.5 18.1579V2.68421C3.5 1.97231 3.81344 1.28957 4.37136 0.786187C4.92928 0.2828 5.68598 2.60723e-08 6.475 2.60723e-08H11.7299ZM11.2 1.57895H6.475C6.15011 1.57895 5.83853 1.69539 5.60879 1.90267C5.37906 2.10995 5.25 2.39108 5.25 2.68421V18.1579C5.25 18.7686 5.7988 19.2632 6.475 19.2632H18.025C18.3499 19.2632 18.6615 19.1467 18.8912 18.9394C19.1209 18.7322 19.25 18.451 19.25 18.1579V8.8421H14.175C13.4109 8.8421 12.6762 8.57687 12.123 8.10137C11.5698 7.62587 11.2405 6.97656 11.2035 6.288L11.2 6.15789V1.57895ZM18.5374 7.26316L12.95 2.22189V6.15789C12.95 6.43538 13.0657 6.7027 13.2741 6.90676C13.4825 7.11082 13.7684 7.23669 14.0749 7.25937L14.175 7.26316H18.5374Z"
								fill={ActiveClass === 4 ? blue : gray}
							/>
						</svg>

						<span className="flex ps-3 text-base sm:text-size_18   font-bold capitalize">
							{t('dashboard.exams')}
						</span>
					</Link>
					{ActiveClass === 4 && <ReactSVG src={checked} />}
				</li>)
			}


			<li className="flex relative " onClick={() => setToggleMenu(false)}>
				<Link
					className={`transition  decoration-clone w-full ${ActiveClass === 6 ? 'text-mainColor' : 'text-textGray'
						} cursor-pointer flex items-center`}
					to={'/announcements'}
					onClick={() => {
						handleActiveClass(6);
						// setToggleMenu()
					}}
				>
					<svg
						width={23}
						height={36}
						viewBox="0 0 28 32"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M13.2632 0.5C11.6421 0.5 10.3158 1.82632 10.3158 3.44737V3.87474C6.07158 5.12737 2.94737 9.07684 2.94737 13.7632V22.6053L0 25.5526V27.0263H13.7789C13.4389 26.0808 13.2644 25.0837 13.2632 24.0789H5.89474V13.7632C5.89474 9.69579 9.19579 6.39474 13.2632 6.39474C17.3305 6.39474 20.6316 9.69579 20.6316 13.7632V15.3695C21.6062 15.1937 22.6044 15.1937 23.5789 15.3695V13.7632C23.5789 9.07684 20.4547 5.12737 16.2105 3.87474V3.44737C16.2105 2.66568 15.9 1.916 15.3473 1.36326C14.7945 0.810525 14.0448 0.5 13.2632 0.5ZM20.6316 18.1842V22.6053H16.2105V25.5526H20.6316V29.9737H23.5789V25.5526H28V22.6053H23.5789V18.1842M10.3158 28.5C10.3159 29.1294 10.5174 29.7422 10.8909 30.2487C11.2644 30.7553 11.7903 31.129 12.3915 31.3151C12.9927 31.5013 13.6377 31.4901 14.2321 31.2831C14.8265 31.0762 15.3391 30.6845 15.6947 30.1653C15.2232 29.6642 14.8105 29.1042 14.4568 28.5H10.3158Z"
							fill="url(#paint0_linear_2421_4802)"
						/>
						<defs>
							<linearGradient
								id="paint0_linear_2421_4802"
								x1={0}
								y1="0.5"
								x2="30.7927"
								y2="28.3604"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor={ActiveClass === 6 ? blue : gray} stopOpacity="0.7" />
								<stop offset="0.723958" stopColor={ActiveClass === 6 ? blue : gray} stopOpacity="0.8" />
							</linearGradient>
						</defs>
					</svg>

					<span className="flex ps-3 text-base sm:text-size_18   font-bold capitalize">
						{t('dashboard.alerts')}
					</span>
				</Link>
				{ActiveClass === 6 && <ReactSVG src={checked} />}
			</li>
		</ul>
	);
};

export default Options;
